import React from 'react';
import { observer } from 'mobx-react-lite';
import styles from './CommonButton.module.css';

type ButtonType =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'outline'
  | 'cancel'
  | 'refresh'
  | 'save'
  | 'delete'
  | 'edit'
  | 'success'
  | 'warning'
  | 'info';

interface CommonButtonProps {
  type?: ButtonType;
  onClick?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
  loading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

const CommonButton: React.FC<CommonButtonProps> = ({
  type = 'primary',
  onClick,
  children,
  disabled = false,
  className = '',
  loading = false,
  leftIcon,
  rightIcon,
}) => {
  const buttonClasses = [
    styles.baseButton,
    styles[type],
    disabled ? styles.disabled : '',
    loading ? styles.loading : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={buttonClasses} onClick={onClick} disabled={disabled || loading}>
      {!loading && leftIcon}
      {children}
      {!loading && rightIcon}
    </button>
  );
};

export default observer(CommonButton);
